import {combineReducers} from 'redux';

import {wizardStep as wizardStepV2} from './wizardStepV2/wizardStep';
import {wizardStep} from 'features/wizardMs/reducers/wizardStep/wizardStep';
import {wizardData} from 'features/wizardMs/reducers/wizardData/wizardData';
import {usages} from 'features/wizardMs/reducers/usages/usages';
import {customerConfiguration} from 'features/wizardMs/reducers/customerConfiguration/customerConfiguration';
import {upsells} from 'features/wizardMs/reducers/upsells/upsells';
import {discountPrice} from 'features/wizardMs/reducers/discountPrice/discountPrice';
import {prescription} from 'features/wizardMs/reducers/prescription';
import {readers} from 'features/wizardMs/reducers/readers/readers';
import {wizardPopup} from './wizardPopup/wizardPopup';

export const reducers = {
    wizardStep,
    wizardData,
    usages,
    customerConfiguration,
    upsells,
    discountPrice,
    prescription,
    readers,
    wizardPopup,
    wizardStepV2,
};

export const wizardMs = combineReducers(reducers);
